import React from 'react';
import { i18n } from 'config/locales';
import Field from 'components/Form/Field';

import { isPVQForm } from 'helpers/form';
import { FormDetails } from 'util/singletons';

const PoliceIntro = function (props) {
  const formDetails = FormDetails.getInstance().getData();
  const isPvq = isPVQForm(formDetails.formType);

  return isPvq ? (
    <div>
      <h1 className="section-header">{i18n.t('legal.pvq.police.heading.title')}</h1>
      <Field optional className="no-margin-bottom">
        {i18n.m('legal.pvq.police.para.intro1')}
        {i18n.m('legal.pvq.police.para.intro2')}
        {i18n.m('legal.pvq.police.para.intro3')}
      </Field>
    </div>
  ) : (
    <div>
      <h1 className="section-header">{i18n.t('legal.police.heading.title')}</h1>
      <Field optional className="no-margin-bottom">
        {i18n.m('legal.police.para.intro1')}
        {i18n.m('legal.police.para.intro2')}
        {i18n.m('legal.police.para.intro3')}
      </Field>
    </div>
  );
};

export default PoliceIntro;
